import React, { useState, useEffect } from 'react';
import { SafeAreaView, View, FlatList, StyleSheet } from 'react-native';
import { Text, Card, Icon } from 'react-native-elements';
import { connect } from 'react-redux';
import { RootState } from '../../redux';
import { User } from '../../utils/types/Users';
import Firebase from '../../components/FirebaseContext';
import { SuccessToast, FailureToast } from '../../utils';
import RNPickerSelect from 'react-native-picker-select';
import 'react-datepicker/dist/react-datepicker.css';
import { Projects } from '../../utils/types/Projects';
import { Tools } from '../../utils/types/Tools';
import { VictoryBar, VictoryChart, VictoryTheme } from 'victory-native';

interface ReportProp {
	user: User;
}

function Report({ user }: ReportProp): JSX.Element {
	const firestore = Firebase.firestore();
	const [loading, setLoading] = useState(false);
	const [projects, setProjects] = useState<Array<Projects>>([]);
	const [selectedProject, setSelectedProject] = useState<Projects>();
	const [tools, setTools] = useState<Array<Tools>>([]);
	const [filteredTools, setFilteredTools] = useState<Array<Tools>>([]);
	const [selectedTool, setSelectedTool] = useState<Tools>();

	useEffect(() => {
		//load all existing projects order by date created desc
		firestore
			.collection('projects')
			.orderBy('createdAt', 'desc')
			.get()
			.then((res) => {
				if (!res.empty) {
					const p = res.docs.map((p) => p.data() as Projects);
					// load all Tools
					firestore
						.collection('tools')
						.get()
						.then((res) => {
							if (!res.empty) {
								const t = res.docs.map((t) => t.data() as Tools);
								setProjects(p);
								setSelectedProject(p[0]);
								// only shows tools available in the selected project
								setTools(t);
								setFilteredTools(t.filter((tool) => p[0].tools.indexOf(tool.id) >= 0));
								setSelectedTool(t.find((tool) => tool.id == p[0].tools[0]));
							}
						});
				}
			});
	}, [firestore]);

	// const data = [
	// 	{ quarter: 1, earnings: 13000 },
	// 	{ quarter: 2, earnings: 16500 },
	// 	{ quarter: 3, earnings: 14250 },
	// 	{ quarter: 4, earnings: 19000 },
	// ];

	return (
		<SafeAreaView style={{ flex: 1, flexDirection: 'row' }}>
			<View style={{ flex: 1 }}>
				<View style={{ flexDirection: 'row', justifyContent: 'space-between', paddingHorizontal: 20 }}>
					<Text style={{ fontWeight: '700', marginBottom: 20, textAlign: 'center', marginTop: 20 }} h4>
						Reports
					</Text>
					<View
						style={{
							flexDirection: 'row',
							alignSelf: 'center',
						}}
					>
						<RNPickerSelect
							onValueChange={(value) => {
								const p = projects.filter((p) => p.id == value)[0];
								setSelectedProject(p);
								// update filtered tools and selected tool
								const t = tools.filter((tool) => p.tools.indexOf(tool.id) >= 0);
								setFilteredTools(t);
								setSelectedTool(t[0]);
							}}
							value={selectedProject?.id}
							items={projects.map((p) => ({ label: p.name, value: p.id }))}
							placeholder={{ label: 'Select option', value: undefined }}
							style={PickerStyle}
						/>
						<RNPickerSelect
							onValueChange={(value) => {
								setSelectedTool(tools.filter((t) => t.id == value)[0]);
							}}
							value={selectedTool?.id}
							items={filteredTools.map((t) => ({ label: t.name, value: t.id }))}
							placeholder={{ label: 'Select option', value: undefined }}
							style={PickerStyle}
						/>
					</View>
				</View>
				<View style={{ flexDirection: 'row', marginTop: 20 }}>
					{/* <VictoryChart width={350} theme={VictoryTheme.material}>
						<VictoryBar data={data} x="quarter" y="earnings" />
					</VictoryChart> */}
				</View>
				{/* <FlatList
					data={savedHias}
					renderItem={({ item }) => {
						const { docId, hia } = item;
						return (
							<Card>
								<Text h4>
									{hia.name} | {hia.id}
								</Text>
								<Text>Address: {hia.address}</Text>
								<Text>Contact Person: {hia.contactName}</Text>
								<Text>
									Email: {hia.contactEmail} | Phone: {hia.contactPhone}
								</Text>
								<View style={{ flexDirection: 'row', position: 'absolute', right: 0 }}>
									<Icon
										reverse
										name="edit-3"
										type="feather"
										size={16}
										color={colors.green}
										onPress={() => {
											setName(hia.name);
											setAddress(hia.address);
											setContactName(hia.contactName);
											setContactEmail(hia.contactEmail);
											setContactPhone(hia.contactPhone);
											setEditId(docId);
										}}
									/>
									<Menu renderer={renderers.Popover} rendererProps={{ preferredPlacement: 'bottom' }}>
										<MenuTrigger>
											<Icon reverse name="trash-2" type="feather" size={16} color={colors.red} />
										</MenuTrigger>
										<MenuOptions customStyles={{ optionsWrapper: { padding: 10 } }}>
											<Text style={{ color: colors.darkRed, fontWeight: '700' }}>This action is irreversible!</Text>
											<View style={{ flexDirection: 'row', justifyContent: 'space-around', marginVertical: 16 }}>
												<MenuOption
													text="Cancel"
													customStyles={{
														optionWrapper: { backgroundColor: colors.blue, borderRadius: 4, paddingHorizontal: 6 },
														optionText: { color: '#fff' },
													}}
												/>
												<MenuOption
													text="Yes delete"
													customStyles={{
														optionWrapper: { backgroundColor: colors.red, borderRadius: 4, paddingHorizontal: 6 },
														optionText: { color: '#fff' },
													}}
													onSelect={async () => {
														await firestore.collection('hias').doc(docId).delete();
														setEditId('refresh');
														SuccessToast(`HIA ${hia.id} has been deleted!`);
													}}
												/>
											</View>
										</MenuOptions>
									</Menu>
								</View>
							</Card>
						);
					}}
					keyExtractor={(item) => item.hia.id}
				/> */}
			</View>
		</SafeAreaView>
	);
}

const PickerStyle = StyleSheet.create({
	inputIOS: {
		paddingVertical: 12,
		paddingHorizontal: 10,
		borderWidth: 0,
		borderColor: 'gray',
		borderRadius: 4,
		color: 'black',
		paddingRight: 30, // to ensure the text is never behind the icon
	},
	inputAndroid: {
		marginLeft: 10,
		paddingHorizontal: 10,
		paddingVertical: 8,
		borderWidth: 0,
		borderColor: '#c5c5c5',
		borderBottomWidth: 1,
		borderRadius: 0,
		color: 'black',
		paddingRight: 30, // to ensure the text is never behind the icon
	},
});

const mapStateToProps = (state: RootState) => {
	const { user } = state;
	return {
		user,
	};
};

export default connect(mapStateToProps)(Report);
